export default __webpack_public_path__ + "static/media/soja_algodao.f1b0b845.svg";